import {
  RoutePairNegYearStatusByRoutePairFragment,
  RoutePairNegotiationYearStatusQuery,
  RoutePairNegotiationYearStatusQueryVariables,
} from "@/gql/graphql";
import { gql, useQuery } from "@apollo/client";

const routePairNegotiationYearStatusQuery = gql`
  fragment RoutePairNegYearStatusByRoutePair on RoutePairNegotiationYear {
    id
    routePair {
      id
      code
    }
    status
    volumeTarget
    year
  }
  query RoutePairNegotiationYearStatus($routePairCode: String!, $year: Int!) {
    productPrice {
      routePairNegotiationYear {
        byRoutePairAndYear(routePairCode: $routePairCode, year: $year) {
          ...RoutePairNegYearStatusByRoutePair
        }
      }
    }
  }
`;

export type RoutePairNavigationYear = RoutePairNegYearStatusByRoutePairFragment;

export const useRoutePairNegotiationYearStatus = (
  routePairCode: string,
  year: number
) => {
  const { data, loading, error } = useQuery<
    RoutePairNegotiationYearStatusQuery,
    RoutePairNegotiationYearStatusQueryVariables
  >(routePairNegotiationYearStatusQuery, {
    variables: { routePairCode, year },
  });

  const routePairData =
    data?.productPrice.routePairNegotiationYear.byRoutePairAndYear;

  return { data: routePairData, loading, error };
};
